import React from "react";
import { Link } from "react-router-dom";
import "./QuestionnaireList.css";

const QuestionnaireList = (props) => {
  return (
    <div className="table_component_main_container">
      <div className="programs_top_hold">
        <input
          type="text"
          ref={props.searchQuestionnaires}
          placeholder="Enter Questionnaire Name or related problem..."
          className="programs_search_bar"
          onChange={() => props.updateSearchQuery(props.searchQuestionnaires.current.value)}
        />
      </div>

      
      <div className="table_scrollable_container_new">
        <div className="table_scrollable_inner_container">



      {props.questionnaireData.length > 0 ? (
        <div className="programs_table">
          <div className="questionnaire_cols">
            <div className="questionnaire_col_info">
              <div className="questionnaire_col_name">Questionnaire Name</div>
              <div
                className="questionnaire_col_icon"
                onClick={() => props.handleSorting("questionnaire_name", props.questionnaireData)}></div>
            </div>
            <div className="questionnaire_col_info">
              <div className="questionnaire_col_name">Questionnaire Type</div>
              <div
                className="questionnaire_col_icon"
                onClick={() => props.handleSorting("questionnaire_type", props.questionnaireData)}></div>
            </div>
            <div className="questionnaire_col_info">
              <div className="questionnaire_col_name">Top Instructions</div>
              <div
                className="questionnaire_col_icon"
                onClick={() => props.handleSorting("top_instructions", props.questionnaireData)}></div>
            </div>
            <div className="questionnaire_col_info">
              <div className="questionnaire_col_name">Bottom Instructions</div>
              <div
                className="questionnaire_col_icon"
                onClick={() => props.handleSorting("bottom_instructions", props.questionnaireData)}></div>
            </div>
            <div className="questionnaire_col_info">
              <div className="questionnaire_col_name">Related Problem</div>
              <div
                className="questionnaire_col_icon"
                onClick={() => props.handleSorting("related_problem", props.questionnaireData)}></div>
            </div>
            <div className="questionnaire_col_info">
              <div className="questionnaire_col_name">Related Subproblem</div>
              <div
                className="questionnaire_col_icon"
                onClick={() => props.handleSorting("related_subproblem", props.questionnaireData)}></div>
            </div>
          </div>
        </div>
      ) : (
        <div className="programs_table_no_content">
          <div className="no_content_notice_contain">
            {props.contentLoaded && props.questionnaireData.length === 0 ? (
              <>
                <div className="questionnaire_no_results_img"></div>
                <div className="questionnaire_no_res_main">No available questionnaires</div>
                <div className="questionnaire_no_res_elab">There are 0 questionnaires available</div>
              </>
            ) : (
              <div className="p_load"></div>
            )}
          </div>
        </div>
      )}
      <div className="tbl_content_hold">
        {props.questionnaireData &&
          props.questionnaireData.map((item, i) => (
            <div key={i} className="questionnaire_tbl_content">
              <Link to={"/questionnaire/" + item.questionnaire_id} style={{ textDecoration: "none" }}>
                <div className="questionnaire_tbl_row">
                  <div className="questionnaire_tbl_col_contain">
                    <div className="questionnaire_tbl_col">{item.questionnaire_name}</div>
                  </div>
                  <div className="questionnaire_tbl_col_contain">
                    <div className="questionnaire_tbl_col tbl_col_no_padd_quest">{item.questionnaire_type}</div>
                  </div>
                  <div className="questionnaire_tbl_col_contain">
                    <div className="questionnaire_tbl_col tbl_col_no_padd_quest">{item.top_instructions}</div>
                  </div>
                  <div className="questionnaire_tbl_col_contain">
                    <div className="questionnaire_tbl_col tbl_col_no_padd_quest">{item.bottom_instructions}</div>
                  </div>
                  <div className="questionnaire_tbl_col_contain">
                    <div className="questionnaire_tbl_col tbl_col_add_padd_quest">{item.related_problem}</div>
                  </div>
                  <div className="questionnaire_tbl_col_contain">
                    <div className="questionnaire_tbl_col tbl_col_add_padd_quest">{item.related_subproblem}</div>
                  </div>
                  <div className="questionnaire_tbl_col_last"></div>
                </div>
              </Link>
            </div>
          ))}
      </div>

      
    </div>
    </div>
    </div>
  );
};

export default QuestionnaireList;
